import api from '../api';

var controllerName = 'manuaiseprocedimentos';

export const getUrlManualProcedimentos = () =>
  api.get<string>(`${controllerName}`);
